// {Componente}{Verbo}{Acción}

// Crear vehículo a partir de la placa
export const VEHICLE_CREATE_BY_PLATE_REQUEST = 'VEHICLE_CREATE_BY_PLATE_REQUEST';
export const VEHICLE_CREATE_BY_PLATE_SUCCESS = 'VEHICLE_CREATE_BY_PLATE_SUCCESS';
export const VEHICLE_CREATE_BY_PLATE_ERROR = 'VEHICLE_CREATE_BY_PLATE_ERROR';

// Crear vehículo a partir del código Fasecolda
export const VEHICLE_CREATE_BY_FASECOLDA_REQUEST = 'VEHICLE_CREATE_BY_FASECOLDA_REQUEST';
export const VEHICLE_CREATE_BY_FASECOLDA_SUCCESS = 'VEHICLE_CREATE_BY_FASECOLDA_SUCCESS';
export const VEHICLE_CREATE_BY_FASECOLDA_ERROR = 'VEHICLE_CREATE_BY_FASECOLDA_ERROR';

// Crear vehículo
export const VEHICLE_CREATE_REQUEST = 'VEHICLE_CREATE_REQUEST';
export const VEHICLE_CREATE_SUCCESS = 'VEHICLE_CREATE_SUCCESS';
export const VEHICLE_CREATE_ERROR = 'VEHICLE_CREATE_ERROR';

// Actualizar los datos del vehículo
export const VEHICLE_UPDATE_REQUEST = 'VEHICLE_UPDATE_REQUEST';
export const VEHICLE_UPDATE_SUCCESS = 'VEHICLE_UPDATE_SUCCESS';
export const VEHICLE_UPDATE_ERROR = 'VEHICLE_UPDATE_ERROR';

export const GLOBAL_QUOTATION_RESET_STATE_VEHICLE = 'GLOBAL_QUOTATION_RESET_STATE_VEHICLE';

// Crear/actualizar vehículo a partir de la REFENCIA
export const VEHICLE_CREATE_BY_REFERENCE_REQUEST = 'VEHICLE_CREATE_BY_REFERENCE_REQUEST';
export const VEHICLE_CREATE_BY_REFERENCE_SUCCESS = 'VEHICLE_CREATE_BY_REFERENCE_SUCCESS';
export const VEHICLE_CREATE_BY_REFERENCE_ERROR = 'VEHICLE_CREATE_BY_REFERENCE_ERROR';
